import {mapGetters, mapMutations, mapActions} from 'vuex';
import * as MEDICINE from '@/store/constants/medicine';
import DownloadCsv from 'vue-json-csv';

// Mixins
import WithFilters from '@/mixins/with-filters';
import WithDateFilters from '@/mixins/with-date-filter';

// Common
import DropDownFilter from '@/views/Common/Filter/DropDownFilter';

import ListWithSpinner from '@/components/ListWithSpinner';
import SearchInput from '@/components/SearchInput';
import TableListActions from '@/components/TableListActions';
import TableRowActions from "@/components/TableRowActions";

export default {
  data() {
    return {
      name: 'MedicineList',
      fields: [
        'name',
        'description',
        'unit',
        'dosage',
        {key: 'enabled', label: 'Active'},
        'created_at',
        'action'
      ],
      isProcessing: false
    }
  },

  computed: {
    ...mapGetters({
      medicines: MEDICINE.GET_MEDICINE_LIST
    }),

    items() {
      return this.medicines.data || [];
    }
  },

  components: {
    DropDownFilter,
    ListWithSpinner,
    SearchInput,
    TableListActions,
    TableRowActions,
    DownloadCsv
  },

  mixins: [WithFilters, WithDateFilters],

  methods: {
    ...mapActions({
      listMedicines: MEDICINE.ACTION_LIST_MEDICINES
    }),

    viewDetail(item) {
      this.$router.push(
        {
          name: 'MedicineDetail',
          params: {id: item.id, medicine: item}
        }
      );
    },

    refreshData() {
      let filters = this.formatFilters();

      if (this.wildcard) {
        filters = {...filters, ...{wildcard: this.wildcard}};
      }

      filters = {
        ...filters, ...{
          page: this.medicines.current_page || 1,
          order_by: ['name,desc'],
        }
      };

      this.isProcessing = true;

      this.listMedicines(filters).then(() => this.isProcessing = false);
    },

    filterList: window._.debounce(function (item) {
      this.wildcard = (item !== '') ? [`name,like,${item}`] : null;
      this.refreshData();
    }, 300),

    handlePaginate() {
      this.refreshData();
    },

    init() {
      this.initializeDateFilter();
      this.refreshData();
    }
  },

  created() {
    this.init();
  }
}



// WEBPACK FOOTER //
// ./src/views/Medicine/js/medicine-list.js